module.exports = __webpack_public_path__ + "static/media/1-2.ee9d7fdf.jpg";